import { FunctionComponent } from 'react'
import { VideoPlayer } from '../../../components/VideoPlayer'
import { User } from '../../../gql/types'
import { Header } from '../components/Header'

interface IProps {
  user: User
}

const CreatorIntroVideo: FunctionComponent<IProps> = ({ user }) => {
  if (!user?.creator.introVideo?.url) {
    return null
  }

  const creator = user.creator

  return (
    <div>
      <Header />

      <div className='px-4 sm:px-0'>
        <h2 className='text-lg leading-6 font-medium text-gray-900'>
          Your Intro Video
        </h2>
        <p className='mt-1 text-sm text-gray-500'>
          If you would like to update your intro video, please email us at{' '}
          <a href='mailto:hello@useclip.com' className='underline'>
            hello@useclip.com
          </a>
          .
        </p>

        <div className='w-full sm:w-4/5 md:w-2/3 lg:w-[400px] mx-auto my-4'>
          <div className='relative isolate flex flex-col justify-end shadow-sm shadow-black/20 dark:shadow-white/20 overflow-hidden rounded-2xl bg-gray-900 aspect-[0.7]'>
            <VideoPlayer
              src={creator.introVideo?.url}
              poster={creator.thumbnail?.url}
              className='absolute inset-0 -z-10 h-full w-full'
              controls
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export { CreatorIntroVideo }
